import * as React from "react";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import { DialogTitle, Typography, Box, DialogContent } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function SampleImageModal({ modalShow, setModalShow, videoPosition }) {
  const handleClose = () => setModalShow(false);
  const [image, setImage] = React.useState('');

  React.useEffect(() => {
    if (videoPosition === 1) setImage("https://backend.whalesai.com/public/1-1-799c8b1ffa4ff5371cf2d0052cfc1c87.png")

    else if (videoPosition === 2) setImage("https://backend.whalesai.com/public/1-1-f3cc322ff2c3b729eb0c055325b83607.png")

    else if (videoPosition === 3) setImage("https://backend.whalesai.com/public/1-1-ece7fc604a77b16f43faa72e72973071.png")

    else setImage("https://backend.whalesai.com/public/1-1-05cc0e8423f5b0469d8921b1aa1de178.png")

  }, [videoPosition])
  return (
    <BootstrapDialog
      onClose={handleClose}
      scroll="body"
      aria-labelledby="customized-dialog-title"
      open={modalShow}
    >
      <Box
        sx={{
          backgroundColor: "#3080ab",
          color: "#fff",
          width: {
            lg: "500px",
          },
        }}
      >
        <DialogTitle
          sx={{ m: 0, p: 2, borderBottom: "2px solid #9a9ead54" }}
          id="customized-dialog-title"
        >
          <div className="d-flex align-items-center justify-content-between gap-2 text-white">
            <Typography variant="h6">Sample</Typography>
            <IconButton
              aria-label="close"
              onClick={handleClose}
            //sx={{
            //     position: "absolute",
            //     right: 8,
            //     top: 8,
            //     color: "white",
            //}}
            >
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>

        <DialogContent>
          <div className="text-center">
            <div className="pngsvgImgdiv mx-auto p-4 d-flex justify-content-center" style={{ width: '280px', height: '280px' }}>
              <img src={image} className="mx-auto" alt="ai" style={{ width: '100%', height: '100%' }} />
            </div>
          </div>

        </DialogContent>
      </Box>
    </BootstrapDialog>
  );
}
